module.exports = __webpack_public_path__ + "static/media/VIDASSISTANCE-F.a00e812f.jpg";